import { isMobile } from '../utilities/check-device-resolution';

const $animatedElems = $('.js-animated-element');
const $scrollToContainer = $('.js-scroll-to');

/**
 * Event listeners
 */
$scrollToContainer.on('click', 'a, button', function(event) {
	event.preventDefault();

	const $this = $(this);
	const $target = $($this.attr('href'));

	if ($this.hasClass('js-scroll-to-btn') && isMobile()) {
		$scrollToContainer.toggleClass('is-active');
		return;
	}

	scrollTo($target);
});

$(document).on('click', function (event) {
  if (!$(event.target).closest('.js-scroll-to').length && isMobile()) {
    $scrollToContainer.removeClass('is-active');
  }
});

/**
 * Check for user scroll
 *
 * @return {Void}
 */
$(document).on('scroll', function(event) {
	$animatedElems.each( (index, el) => {
		if (userHasScrolledToElem(el)) {
			$(el).addClass('is-animated');
		}
	});
});

/**
 * Check if user has scrolled to elem
 *
 * @param  {DOM elem} elem
 * @return {Boolean}
 */
const userHasScrolledToElem = elem => {
	const scrollPos = $(window).scrollTop() + $(window).height() * 0.8;
	const elemPos = $(elem).offset().top;

	return scrollPos >= elemPos;
}

/**
 * Scroll to section
 * @param  {JQuery elem} $section
 */
const scrollTo = $section => {
	if (! $section) {
		return;
	}

	const headerHeight = $('.js-header').outerHeight();

	$('html, body').animate({
		scrollTop: $section.offset().top - headerHeight
	}, 400);
}

$(window).on('resize', function(event) {
	event.preventDefault();
	if ($scrollToContainer.hasClass('is-active') && !isMobile()) {
		$scrollToContainer.removeClass('is-active');
	}
});

/**
 * Check if user is on mobile device
 *
 * @return {Void}
 */

const deviceIsMobile = () => $(window).outerWidth() <= MOBILE_BREAKPOINT;
